import { colors as ionColors } from './ion/colors'

export const colors = {
  alert: {
    danger: {
      10: '#FFF6F4',
      20: '#FFD8CF',
      30: '#C93934',
      40: '#A83632',
      50: '#80221F',
      dark: '#C93934', // NOTE: same as 30
      darker: '#A12E2A',
      light: '#FFA48D',
      main: '#FF4842',
    },
    info: {
      20: '#CDE6FF',
      40: '#003F98',
      dark: '#0C53B7',
      darker: '#04297A',
      light: '#74CAFF',
      ligther: '#E8F6FF',
      main: '#1890FF',
    },
    success: {
      10: '#F5FBF4',
      20: '#DFF3DC',
      30: '#229A16',
      40: '#1B7811',
      50: '#14560D',
      dark: '#229A16', // NOTE: same as 30
      darker: '#08660D',
      light: '#AAF27F',
      main: '#54D62C',
    },
    warning: {
      10: '#FFF5DD',
      20: '#FFE88E',
      30: '#EDA31D',
      40: '#D7900E',
      50: '#BC7900',
      dark: '#EDA31D', // NOTE: same as 30
      darker: '#CF8D00',
      light: '#FFE16A',
      main: '#FFC107',
    },
  },
  // UPDATED ION COLORS (USED ON FIGMA)
  ion: ionColors,
  neutral: {
    20: '#F9F9F9',
    40: '#E6E6E6',
    50: '#808080',
    60: '#8E8E8E',
    80: '#4A4A4B',
    90: '#1A1A1E',
    '100': '#F9F9F9',
    '700': '#454F5B',
    black: '#1A1A1E', // NOTE: same as 90
    clear: '#ECECEC',
    high: '#4A4A4B',
    light: '#8E8E8E',
    lighthover: '#D2D2D2',
    medium: '#6C6D6E',
    mediumhover: '#BCBCBC',
    // Normalized with Figma
    softer: '#F0F0F0',
    white: '#FFFFFF',
    wrapicon: '#F3F6FB',
  },
  primary: {
    20: '#062788',
    60: '#2A62F6',
    80: '#DCEAFF',
    90: '#EBF2FF',
    hover: '#000081',
    main: '#0064FF',
  },
  quartenary: '#F3F6FB',
  secondary: '#FF0000',
  support: {
    disabled: '#B4D0FA',
    error: '#A0192A',
    first: '#00917D',
    fourth: '#FF8394',
    red: '#AD0606',
    redhover: '#910808',
    second: '#953FDB',
    success: '#2CAC40',
    successhover: '#1E782C',
    third: '#AE482B',
    warning: '#E58221',
  },
  tertiary: '#FF8394',
} as const
